import React from 'react';

import { Box, Button, Flex, Paragraph } from '@flightstats/airframe-react';

import { CiriumPage } from '../../components/cirium/CiriumPage';
import {
  TravelerRegisterForm,
  TravelerRegisterFormProps,
} from './TravelerRegisterForm';
import { CiriumModal } from '../../components/cirium/CiriumModal';
import styles from './travelerRegisterForm.module.css';

export type TravelerRegisterPageProps = TravelerRegisterFormProps & {
  brandingImageUrl?: string | null;
  displayExistingUsernameMsg: boolean;
  closeExistingUsernameMsg: () => void;
};

export const TravelerRegisterPage: React.FC<TravelerRegisterPageProps> = (props) => (
  <CiriumPage
    brandingImageUrl={props.brandingImageUrl}
    title="Trip Alert Registration"
  >
    <Box className={styles.boxPadding}>
      <Paragraph limitWidth={false}>
        Welcome to Trip Alert! After you create a profile, Trip Alert will send
        you alert messages to your email or phone for your current and future
        trips. You can change your delivery options or disable Trip Alert by
        updating your profile at any time.
      </Paragraph>
      <Paragraph limitWidth={false}>
        {props.isExistingUsername
          ? 'Please enter an email, username, and password for Trip Alert and then click on the submit button.'
          : 'Please enter an email and password for Trip Alert and then click on the submit button.'}
      </Paragraph>
    </Box>
    <TravelerRegisterForm {...props} />
    <CiriumModal
      showModal={props.displayExistingUsernameMsg}
      closeModal={props.closeExistingUsernameMsg}
      title={'Username Previously Registered'}
    >
      <Paragraph>
        This username has been previously registered for another Trip Alert
        account. Click OK to enter a new username.
      </Paragraph>
      <Flex className={styles.flexCenter}>
        <Button className={styles.modalButton} onClick={props.closeExistingUsernameMsg}>
          OK
        </Button>
      </Flex>
    </CiriumModal>
  </CiriumPage>
);